import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/jira': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M490 241.7c8 7.9 8 20.7 0 28.6-225.8 225 137.9-136.3-241.5 241.7-180.7-180.1-109.7-109.3-242.5-241.6-7.9-8-7.9-20.8 0-28.7 0 0 77-76.8 242.5-241.7 72.1 71.8 168.6 169 241.5 241.7zM248.5 331.7l76-75.7-76-75.7-76 75.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/jira.js
// module id = 897
// module chunks = 0